import { render, staticRenderFns } from "./TripsDetails.vue?vue&type=template&id=7aa83584&scoped=true"
import script from "./TripsDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TripsDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TripsDetails.vue?vue&type=style&index=0&id=7aa83584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa83584",
  null
  
)

export default component.exports